// extracted by mini-css-extract-plugin
export default {"link":"SurveysTableTitle_link__WeOPj","placeHolderShimmer":"SurveysTableTitle_placeHolderShimmer__ULFlI"};